export default {
  methods: {
    exportTables () {
      const tblMain = this.$refs.main
      const tblStatistics = this.$refs.statistics
      tblMain && tblMain.exportTable()
      tblStatistics && tblStatistics.exportTable()
    },
    updateMain (mainParams, searchResult) {
      const resultData = searchResult.data
      if (this.main.pagination) {
        Object.assign(this.main.pagination, {
          page: resultData.pageNum,
          rowsNumber: resultData.pageTotal,
          rowsPerPage: mainParams.page.pageSize,
          sortBy: mainParams.page.orderBy?.length ? mainParams.page.orderBy[0].name : undefined,
          descending: mainParams.page.orderBy?.length ? mainParams.page.orderBy[0].order === 'desc' : false
        })
      }
      this.main.dataFilters = mainParams.filters
      this.main.data = resultData.data || []
    },
    buildMainParams (searchParams) {
      const mainPagination = searchParams?.pagination || this.main.pagination
      const modelFilters = searchParams?.filters || { ...this.filters.model }
      const sortByField = this.$refs.main.computedColumnsMap?.get(mainPagination.sortBy)
      Object.keys(modelFilters).map(v => {
        if (modelFilters[v] === '') {
          modelFilters[v] = null
        }
      })
      return {
        filters: modelFilters,
        page: mainPagination ? {
          pageNum: mainPagination.page ?? 1,
          pageSize: mainPagination.rowsPerPage ?? 99999999,
          orderBy: sortByField ? [
            {
              name: sortByField.name,
              field: typeof sortByField.field === 'function' ? (sortByField.sortBy ?? sortByField.name) : sortByField.field,
              order: mainPagination.descending ? 'desc' : 'asc'
            }
          ] : undefined
        } : undefined
      }
    }
  }
}
